export var CoopConstants;
(function (CoopConstants) {
    CoopConstants[CoopConstants["CoolDownTime"] = 36000] = "CoolDownTime";
    CoopConstants[CoopConstants["DifficultyLevelMax"] = 5] = "DifficultyLevelMax";
    CoopConstants[CoopConstants["LoyaltyPointsResourceId"] = 23] = "LoyaltyPointsResourceId";
    CoopConstants[CoopConstants["MaxChatUnreadMessageCount"] = 9] = "MaxChatUnreadMessageCount";
    CoopConstants[CoopConstants["ProbationPeriodInSeconds"] = 86400] = "ProbationPeriodInSeconds";
})(CoopConstants || (CoopConstants = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/CoopConstants.ts
// module id = 269
// module chunks = 3